// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"1d571ac1","796":"0f58e1db"}[chunkId] + ".chunk.js";
};